precision mediump float;

uniform sampler2D uSign;
uniform sampler2D uSnow;
uniform vec3 uColor;
uniform float uOpacity;
uniform float uSignScale;
uniform float uSnowScale;

varying vec2 vUv;

void main() {
    vec2 signUv = (vUv - 0.5) / max(uSignScale, 0.0001) + 0.5;
    signUv.y -= 0.05;
    signUv.x -= 0.05;
    vec4 signTex = texture2D(uSign, signUv);
    vec2 snowUv = (vUv - 0.5) / max(uSnowScale, 0.0001) + 0.5;
    vec4 snowTex = texture2D(uSnow, snowUv);
    float aSign = signTex.r;
    float aSnow = snowTex.r;
    float a = aSign * aSnow * uOpacity;
    if (a <= 0.001) discard;
    gl_FragColor = vec4(uColor, a);
}


